<template>
  <div>
    <NavBar />
    <!-- overflow-y: scroll;
      padding-bottom: 15rem; -->
    <div style="background: #12102e;

      background-size: cover;
      background-attachment: fixed;">

      <div class="col-lg-12 px-0 col-12 mx-auto d-flex main-image-wrapper">
        <b-carousel
          id="carousel-1"
          :interval="3000"
          controls
          fade
          style="width: 100%; height: 100%;"
          class="p-3"
        >
          <b-carousel-slide
            img-src="https://www.burma368.net/cms-profile/file/2025/10/05/mobilesize_20251005173335A170.jpg"
          ></b-carousel-slide>
        </b-carousel>
      </div>
      <div
        class="d-flex px-0 px-3 mx-auto mt-0 mb-2"
        style="
          width: 100%;
          z-index: 10;
          padding-top: 2px;
          padding-bottom: 3px;
          background: transparent !important;
          margin-top: -0.7rem !important;
        "
      >
        <i
          class="fas fa-volume-up my-auto pr-3"
          style="font-size: 14px; font-weight: 600; color: white"
        ></i>
        <NoticeBar
          class="mx-0 px-0 mx-auto notice-bar col-11"
          scrollable
          speed="40"
          :text="websiteInfo.noticeText"
          v-if="!threedData.embedded_link && !threedData.isLive"
        />
      </div>

      <div
        class="flex items-center mt-2 overflow-x-scroll gap-3 scroll-bar-none mx-auto"
        style="width: 95%; margin-top: -0.3rem !important;"
      >
        <TabItem
          value="hot"
          @click="changeSideNav('hot')"
          :label="$t('home.hot')"
          icon="https://space-tech.sgp1.cdn.digitaloceanspaces.com/ak47/general/hot-ak47.png"
          activeIcon="https://space-tech.sgp1.cdn.digitaloceanspaces.com/ak47/general/hot-ak47-active.png"
          :isActive="$store.state.sideNav === 'hot'"
        />
        <TabItem
          value="slot"
          @click="changeSideNav('slot')"
          :label="$t('home.slot')"
          icon="https://space-tech.sgp1.cdn.digitaloceanspaces.com/ak47/general/slot-ak47.png"
          activeIcon="https://space-tech.sgp1.cdn.digitaloceanspaces.com/ak47/general/slot-ak47-active.png"
          :isActive="$store.state.sideNav === 'slot'"
        />
        <TabItem
          value="card"
          @click="changeSideNav('card')"
          :label="$t('home.card')"
          icon="https://space-tech.sgp1.cdn.digitaloceanspaces.com/ak47/general/card-ak47.png"
          activeIcon="https://space-tech.sgp1.cdn.digitaloceanspaces.com/ak47/general/card-ak47-active.png"
          :isActive="$store.state.sideNav === 'card'"
        />
        <TabItem
          value="fishing"
          @click="changeSideNav('fishing')"
          :label="$t('home.fishing')"
          icon="https://space-tech.sgp1.cdn.digitaloceanspaces.com/ak47/general/fish-ak47.png"
          activeIcon="https://space-tech.sgp1.cdn.digitaloceanspaces.com/ak47/general/fish-ak47-active.png"
          :isActive="$store.state.sideNav === 'fishing'"
        />
        <TabItem
          value="arcade"
          @click="changeSideNav('arcade')"
          :label="$t('home.arcade')"
          icon="https://space-tech.sgp1.cdn.digitaloceanspaces.com/ak47/general/arcade-ak47.png"
          activeIcon="https://space-tech.sgp1.cdn.digitaloceanspaces.com/ak47/general/arcade-ak47-active.png"
          :isActive="$store.state.sideNav === 'arcade'"
        />
        <TabItem
          value="live"
          @click="changeSideNav('live')"
          :label="$t('home.lc')"
          icon="https://space-tech.sgp1.cdn.digitaloceanspaces.com/ak47/general/arcade-ak47.png"
          activeIcon="https://space-tech.sgp1.cdn.digitaloceanspaces.com/ak47/general/arcade-ak47-active.png"
          :isActive="$store.state.sideNav === 'live'"
        />
        <TabItem
          value="buffalo"
          @click="changeSideNav('buffalo')"
          :label="$t('home.buffalo')"
          icon="https://space-tech.sgp1.cdn.digitaloceanspaces.com/ak47/general/arcade-ak47.png"
          activeIcon="https://space-tech.sgp1.cdn.digitaloceanspaces.com/ak47/general/arcade-ak47-active.png"
          :isActive="$store.state.sideNav === 'buffalo'"
        />
      </div>
      <div class="cards-container-mobile">
        <div
          class="container-fluid justify-content-end px-0 d-flex pt-0"
          style="position: relative; margin-top: -0.8rem !important;"
        >
          <div
            class="index_rightbar mr-0 pl-0 col-12 pl-2 pr-1"
            id="index_rightbar"
            style="height: 100vh; overflow-y: scroll; position: absolute"
          >
            <div>
              <div
                class="tab-content game px-1 pr-2"
                style="min-height: 50vh; border-radius: 20px; height: auto"
              >
                <!-- Hot Games -->
                <div
                  class="mx-1 mt-2"
                  :class="$store.state.sideNav === 'hot' ? 'active' : ''"
                  v-show="$store.state.sideNav === 'hot'"
                >
                  <div>
                    <!-- Slot Games -->
                    <div class="col-12 p-0 py-1 -mt-1">
                      <div class="d-flex">
                        <img
                          src="https://hj-hashgo.s3.ap-southeast-1.amazonaws.com/80001001/zh-CN/factory_channel_category/hot-1.png?t=11/4/2025"
                          style="width: 1.5rem"
                          class="my-2 mb-3 mr-2"
                        />
                        <div>
                          <h4
                            class="text-nowrap font-semibold pt-1"
                            style="color: white; font-size: 1.3rem !important;"
                          >
                            {{ $t("home.popular_slot_games") }}
                          </h4>
                        </div>
                      </div>

                      <div class="d-flex flex-wrap">
                        <Swiper
                          :modules="[Autoplay]"
                          :slides-per-view="hotGames['slotGames'].length > 3 ? 3.7 : hotGames['slotGames'].length"
                          :space-between="10"
                          :loop="true"
                          :autoplay="{
                            delay: 3300,
                          }"
                          :pagination="{ clickable: true }"
                          :initial-slide="0"
                          class="responsible-swiper"
                          :looped-slides="3"
                        >
                          <SwiperSlide
                            v-for="slotGame in hotGames['slotGames']"
                            :key="slotGame.id"
                          >
                            <GameCard
                              @click="
                                slotGame.provider === 'PGSoft' ||
                                  slotGame.provider === 'FaChai'
                                  ? showAlertBox(slotGame)
                                  : gameInit(slotGame)
                                "
                              :game="slotGame"
                            />
                          </SwiperSlide>
                        </Swiper>
                      </div>
                    </div>


                    <!-- Fishing Games -->
                    <div class="col-12 p-0 py-1 -mt-1">
                      <div class="d-flex">
                        <img
                          src="https://hj-hashgo.s3.ap-southeast-1.amazonaws.com/80001001/zh-CN/factory_channel_category/fishing-1.png?t=11/4/2025"
                          style="width: 1.5rem"
                          class="my-2 mb-3 mr-2"
                        />
                        <div>
                          <h4
                            class="text-nowrap font-semibold pt-1"
                            style="color: white; font-size: 1.3rem !important;"
                          >
                            {{ $t("home.popular_fishing_games") }}
                          </h4>
                        </div>
                      </div>

                      <div class="d-flex flex-wrap">
                        <Swiper
                          :modules="[Autoplay]"
                          :slides-per-view="hotGames['fishingGames'].length > 3 ? 3.7 : hotGames['fishingGames'].length"
                          :space-between="10"
                          :loop="true"
                          :autoplay="{
                            delay: 3300,
                          }"
                          :pagination="{ clickable: true }"
                          :initial-slide="0"
                          class="responsible-swiper"
                          :looped-slides="3"
                        >
                          <SwiperSlide
                            v-for="fishingGame in hotGames['fishingGames']"
                            :key="fishingGame.id"
                          >
                            <GameCard
                              @click="
                                fishingGame.provider === 'PGSoft' ||
                                  fishingGame.provider === 'FaChai'
                                  ? showAlertBox(fishingGame)
                                  : gameInit(fishingGame)
                                "
                              :game="fishingGame"
                            />
                          </SwiperSlide>
                        </Swiper>
                      </div>
                    </div>

                    <!-- Arcade Games -->
                    <div class="col-12 p-0 py-1 -mt-1">
                      <div class="d-flex">
                        <img
                          src="https://hj-hashgo.s3.ap-southeast-1.amazonaws.com/80001001/zh-CN/factory_channel_category/card-1.png?t=11/4/2025"
                          style="width: 1.6rem"
                          class="my-2 mb-3 mr-2"
                        />
                        <div>
                          <h4
                            class="text-nowrap font-semibold pt-1"
                            style="color: white; font-size: 1.3rem !important;"
                          >
                            {{ $t("home.popular_arcade_games") }}
                          </h4>
                        </div>
                      </div>

                      <div class="d-flex flex-wrap">
                        <Swiper
                          :modules="[Autoplay]"
                          :slides-per-view="hotGames['arcadeGames'].length > 3 ? 3.7 : hotGames['arcadeGames'].length"
                          :space-between="10"
                          :loop="true"
                          :autoplay="{
                            delay: 3300,
                          }"
                          :pagination="{ clickable: true }"
                          :initial-slide="0"
                          class="responsible-swiper"
                          :looped-slides="3"
                        >
                          <SwiperSlide
                            v-for="arcadeGame in hotGames['arcadeGames']"
                            :key="arcadeGame.id"
                          >
                            <GameCard
                              @click="
                                arcadeGame.provider === 'PGSoft' ||
                                  arcadeGame.provider === 'FaChai'
                                  ? showAlertBox(arcadeGame)
                                  : gameInit(arcadeGame)
                                "
                              :game="arcadeGame"
                            />
                          </SwiperSlide>
                        </Swiper>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- SKM Games -->
                <div
                  class="!flex items-center flex-wrap mt-4"
                  :class="$store.state.sideNav === 'skm' ? 'active' : ''"
                  v-if="$store.state.sideNav === 'skm'"
                >
                  <img
                    class="mx-1 my-1"
                    src="https://yy24gld.sgp1.cdn.digitaloceanspaces.com/general/%E1%80%9C%E1%80%B0%E1%80%9E%E1%80%85%E1%80%BA.png"
                    alt="skm"
                    style="cursor: pointer; width: 31%; height: auto"
                    @click="fetchShanKoMeeData(0)"
                  />
                  <img
                    class="mx-1 my-1"
                    src="https://yy24gld.sgp1.cdn.digitaloceanspaces.com/general/%E1%80%82%E1%80%BB%E1%80%B0%E1%80%94%E1%80%AE%E1%80%9A%E1%80%AC.png"
                    alt="skm"
                    style="cursor: pointer; width: 31%; height: auto"
                    @click="fetchShanKoMeeData(1)"
                  />
                  <img
                    class="mx-1 my-1"
                    src="https://yy24gld.sgp1.cdn.digitaloceanspaces.com/general/%E1%80%85%E1%80%AE%E1%80%94%E1%80%AE%E1%80%9A%E1%80%AC.png"
                    alt="skm"
                    style="cursor: pointer; width: 31%; height: auto"
                    @click="fetchShanKoMeeData(2)"
                  />
                  <img
                    class="mx-1 my-1"
                    src="https://yy24gld.sgp1.cdn.digitaloceanspaces.com/general/%E1%80%98%E1%80%B1%E1%80%AC%E1%80%B7%E1%80%85%E1%80%BA.png"
                    alt="skm"
                    style="cursor: pointer; width: 31%; height: auto"
                    @click="fetchShanKoMeeData(3)"
                  />
                  <img
                    class="mx-1 my-1"
                    src="https://yy24gld.sgp1.cdn.digitaloceanspaces.com/general/%E1%80%99%E1%80%AE%E1%80%9C%E1%80%AE%E1%80%9A%E1%80%B6%E1%80%94%E1%80%AC.png"
                    alt="skm"
                    style="cursor: pointer; width: 31%; height: auto"
                    @click="fetchShanKoMeeData(4)"
                  />
                  <img
                    class="mx-1 my-1"
                    src="https://yy24gld.sgp1.cdn.digitaloceanspaces.com/general/%E1%80%98%E1%80%AE%E1%80%9C%E1%80%AE%E1%80%9A%E1%80%B6%E1%80%94%E1%80%AC.png"
                    alt="skm"
                    style="cursor: pointer; width: 31%; height: auto"
                    @click="fetchShanKoMeeData(5)"
                  />
                </div>

                <!-- BGY Games -->
                <div
                  class="!flex items-center flex-wrap mt-4"
                  :class="$store.state.sideNav === 'bgy' ? 'active' : ''"
                  v-if="$store.state.sideNav === 'bgy'"
                >
                  <img
                    class="mx-1 my-1"
                    src="https://yy24gld.sgp1.cdn.digitaloceanspaces.com/general/%E1%80%9C%E1%80%B0%E1%80%9E%E1%80%85%E1%80%BA.png"
                    alt="bgy"
                    style="cursor: pointer; width: 31%; height: auto"
                    @click="fetchBugyee(0)"
                  />
                  <img
                    class="mx-1 my-1"
                    src="https://yy24gld.sgp1.cdn.digitaloceanspaces.com/general/%E1%80%82%E1%80%BB%E1%80%B0%E1%80%94%E1%80%AE%E1%80%9A%E1%80%AC.png"
                    alt="bgy"
                    style="cursor: pointer; width: 31%; height: auto"
                    @click="fetchBugyee(1)"
                  />
                  <img
                    class="mx-1 my-1"
                    src="https://yy24gld.sgp1.cdn.digitaloceanspaces.com/general/%E1%80%85%E1%80%AE%E1%80%94%E1%80%AE%E1%80%9A%E1%80%AC.png"
                    alt="bgy"
                    style="cursor: pointer; width: 31%; height: auto"
                    @click="fetchBugyee(2)"
                  />
                  <img
                    class="mx-1 my-1"
                    src="https://yy24gld.sgp1.cdn.digitaloceanspaces.com/general/%E1%80%98%E1%80%B1%E1%80%AC%E1%80%B7%E1%80%85%E1%80%BA.png"
                    alt="bgy"
                    style="cursor: pointer; width: 31%; height: auto"
                    @click="fetchBugyee(3)"
                  />
                  <img
                    class="mx-1 my-1"
                    src="https://yy24gld.sgp1.cdn.digitaloceanspaces.com/general/%E1%80%99%E1%80%AE%E1%80%9C%E1%80%AE%E1%80%9A%E1%80%B6%E1%80%94%E1%80%AC.png"
                    alt="bgy"
                    style="cursor: pointer; width: 31%; height: auto"
                    @click="fetchBugyee(4)"
                  />
                  <img
                    class="mx-1 my-1"
                    src="https://yy24gld.sgp1.cdn.digitaloceanspaces.com/general/%E1%80%98%E1%80%AE%E1%80%9C%E1%80%AE%E1%80%9A%E1%80%B6%E1%80%94%E1%80%AC.png"
                    alt="bgy"
                    style="cursor: pointer; width: 31%; height: auto"
                    @click="fetchBugyee(5)"
                  />
                </div>

                <!-- Card Games -->
                <div
                  class="pb-2 mx-0 px-0 !grid grid-cols-4 gap-2 mt-3"
                  :class="$store.state.sideNav === 'card' ? 'active' : ''"
                  v-if="$store.state.sideNav === 'card'"
                >
                  <div class="flex flex-col gap-3 justify-center">
                    <div
                      class="w-full h-[120px]"
                      @click="changeSideNav('skm')"
                    >
                      <div class="w-full h-full rounded-[38px] relative">
                        <img
                          src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/shwespin/cards/shwespin_card_shankoemee.webp"
                          alt=""
                          class="w-full h-full rounded-[38px]"
                        />

                        <img
                          src="https://www.burma368.net/static/image/home/game-item-border-image.png"
                          class="absolute top-0 left-0 w-full h-full"
                          alt=""
                        />
                        <img
                          src="https://www.burma368.net/static/image/home/game-item-play.png"
                          class="w-[40px] h-[40px] absolute bottom-0 right-0"
                          alt=""
                        />
                      </div>
                    </div>
                  </div>
                  <div class="flex flex-col gap-3 justify-center">
                    <div
                      class="w-full h-[120px]"
                      @click="changeSideNav('bgy')"
                    >
                      <div class="w-full h-full rounded-[38px] relative">
                        <img
                          src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/shwespin/cards/shwespin_card_bugyi.webp"
                          alt=""
                          class="w-full h-full rounded-[38px]"
                        />

                        <img
                          src="https://www.burma368.net/static/image/home/game-item-border-image.png"
                          class="absolute top-0 left-0 w-full h-full"
                          alt=""
                        />
                        <img
                          src="https://www.burma368.net/static/image/home/game-item-play.png"
                          class="w-[40px] h-[40px] absolute bottom-0 right-0"
                          alt=""
                        />
                      </div>
                    </div>
                  </div>
                  <div class="flex flex-col gap-3 justify-center">
                    <div
                      class="w-full h-[120px]"
                      @click="fetchForestData()"
                    >
                      <div class="w-full h-full rounded-[38px] relative">
                        <img
                          src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/shwespin/cards/shwespin_card_rabbit.webp"
                          alt=""
                          class="w-full h-full rounded-[38px]"
                        />

                        <img
                          src="https://www.burma368.net/static/image/home/game-item-border-image.png"
                          class="absolute top-0 left-0 w-full h-full"
                          alt=""
                        />
                        <img
                          src="https://www.burma368.net/static/image/home/game-item-play.png"
                          class="w-[40px] h-[40px] absolute bottom-0 right-0"
                          alt=""
                        />
                      </div>
                    </div>
                  </div>
                  <div class="flex flex-col gap-3 justify-center">
                    <div
                      class="w-full h-[120px]"
                      @click="fetchGaloneData()"
                    >
                      <div class="w-full h-full rounded-[38px] relative">
                        <img
                          src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/shwespin/cards/shwespin_galonegalone.webp"
                          alt=""
                          class="w-full h-full rounded-[38px]"
                        />

                        <img
                          src="https://www.burma368.net/static/image/home/game-item-border-image.png"
                          class="absolute top-0 left-0 w-full h-full"
                          alt=""
                        />
                        <img
                          src="https://www.burma368.net/static/image/home/game-item-play.png"
                          class="w-[40px] h-[40px] absolute bottom-0 right-0"
                          alt=""
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Fishing Games -->
                <div
                  class="pb-3 !grid grid-cols-4 gap-2 mt-3"
                  :class="$store.state.sideNav === 'fishing' ? 'active' : ''"
                  v-if="$store.state.sideNav === 'fishing'"
                >
                  <ProviderCard
                    v-for="provider in fishProviders"
                    :key="provider.id"
                    :provider="provider"
                    @click="$router.push(`/user/fishing?provider=${provider.code}`)"
                  />
                </div>

                <!-- Slot Games -->
                <div
                  :class="$store.state.sideNav === 'slot' ? 'active' : ''"
                  v-if="$store.state.sideNav === 'slot'"
                  class="pb-2 mx-0 px-0 !grid gap-2 mt-3 grid-cols-4"
                >
                  <ProviderCard
                    v-for="provider in slotProviders"
                    :key="provider.id"
                    :provider="provider"
                    @click="$router.push(`/user/slots?provider=${provider.code}`)"
                  />
                </div>

                <!-- Football Games -->
                <div
                  :class="$store.state.sideNav === 'football' ? 'active' : ''"
                  v-if="$store.state.sideNav === 'football'"
                  class="d-flex justify-content-between flex-wrap"
                >
                  <img
                    src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/pg-boss/cards/Body.png"
                    alt="football"
                    class="my-2 px-0 mx-0"
                    style="cursor: pointer; width: 49%; height: auto"
                    @click="$router.push('/body-fb')"
                  />
                  <img
                    src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/pg-boss/cards/Maung.png"
                    alt="football"
                    class="my-2 px-0 mx-0"
                    style="cursor: pointer; width: 49%; height: auto"
                    @click="$router.push('/maung-fb')"
                  />
                  <!-- <img src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/hulk333/general/hulk_live.png" alt="skm" class="my-2 px-0 mx-0" style="cursor: pointer; width: 49%; height: auto;" @click="$router.push('/Live')"> -->
                </div>

                <!-- Arcade Games -->
                <div
                  :class="$store.state.sideNav === 'arcade' ? 'active' : ''"
                  v-if="$store.state.sideNav === 'arcade'"
                  class="!grid grid-cols-4 gap-2 mt-3"
                >
                  <ProviderCard
                    v-for="provider in arcadeProviders"
                    :key="provider.id"
                    :provider="provider"
                    @click="$router.push(`/user/arcade?provider=${provider.code}`)"
                  />
                </div>

                <!-- Live Providers -->
                <div
                  :class="$store.state.sideNav === 'live' ? 'active' : ''"
                  v-if="$store.state.sideNav === 'live'"
                  class="!grid grid-cols-4 gap-2 mt-3"
                >
                  <ProviderCard
                    v-for="provider in liveProviders"
                    :key="provider.id"
                    :provider="provider"
                    @click="$router.push(`/user/live?provider=${provider.code}`)"
                  />
                </div>

                <!-- Casino Games -->
                <div
                  :class="$store.state.sideNav === 'casino' ? 'active' : ''"
                  v-if="$store.state.sideNav === 'casino'"
                  class="d-flex justify-content-between flex-wrap"
                >
                  <img
                    src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/pg-boss/cards/Live%20Casino%20-%20PP.png"
                    alt="casino"
                    class="my-2 px-0 mx-0"
                    style="cursor: pointer; width: 48%; height: auto"
                    @click="gameInitCasino('PP Live')"
                  />
                  <img
                    src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/pg-boss/cards/Live%20Casino%20-%20Sexy.png"
                    alt="casino"
                    class="my-2 px-0 mx-0"
                    style="cursor: pointer; width: 48%; height: auto"
                    @click="gameInitCasino('Sexy')"
                  />
                  <img
                    src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/pg-boss/cards/Live%20Casino%20-%20WM.png"
                    alt="casino"
                    class="my-2 px-0 mx-0"
                    style="cursor: pointer; width: 48%; height: auto"
                    @click="gameInitCasino('WM')"
                  />
                  <img
                    src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/pg-boss/cards/Live%20Casino%20-%20Big%20Gaming.png"
                    alt="skm"
                    class="my-2 px-0 mx-0"
                    style="cursor: pointer; width: 48%; height: auto"
                    @click="gameInitCasino('BG')"
                  />
                </div>

                <!-- Download Games -->
                <div
                  :class="$store.state.sideNav === 'download' ? 'active' : ''"
                  v-if="$store.state.sideNav === 'download'"
                >
                  <div class="gwrap_1 pb-3">
                    <h4 class="text-center text-white mt-3">
                      {{ $t("home.you_download") }} <br />
                      {{ $t("home.on_any_platform") }}
                    </h4>
                    <a
                      href="https://backapi.space97.vip/api/app/download/android"
                      download="melonzeed.apk"
                    >
                      <img
                        src="https://cdn.gold549.com/build/assets/img/brand/android-download.png"
                        alt="slot"
                        style="cursor: pointer; width: 50%; height: auto"
                      />
                    </a>
                    <a
                      href="https://backapi.space97.vip/api/app/download/ios"
                      download="melonzeed.mobileconfig"
                    >
                      <img
                        src="https://cdn.gold549.com/build/assets/img/brand/ios-download.png"
                        alt="slot"
                        style="
                          cursor: pointer;
                          width: 50%;
                          height: auto;
                          margin-top: 0.1rem;
                        "
                      />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>


    <van-overlay :show="isLoading">
      <div
        class="wrapper"
        @click.stop
      >
        <van-loading
          type="spinner"
          color="#ffffff"
          class="mx-auto"
        />
      </div>
    </van-overlay>

    <!-- <LiveChatWidget license="18638211" v-if="testing"/> -->

    <div class="col-4">
      <div
        class="modal fade"
        id="limit"
        tabindex="-1"
        role="dialog"
        aria-labelledby="modal-form"
        @click="hideLimit()"
      >
        <div
          class="modal-dialog modal- modal-dialog-centered"
          role="document"
        >
          <div class="modal-content">
            <div class="modal-body my-5 mx-3 text-center">
              <span class="text-danger text-lg">
                <b>အထူးသတိပြုရန်။</b> <br /><br />
              </span>
              <span>{{ limitText }}</span>
              <br /><br />
              <span class="text-dark text-sm">
                <button
                  class="btn btn-danger"
                  @click="gameInit(desiredGame)"
                >
                  {{
                    $store.state.language === "en"
                      ? "Play The Game"
                      : "ဂိမ်းဆော့မည်။"
                  }}
                </button>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NavBar from "@/layouts/NavBar.vue";
import { NoticeBar, Dialog, Toast, Sticky } from "vant";
import { mapActions, mapState } from "vuex";
import { LiveChatWidget } from "@livechat/widget-vue";
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Pagination, Autoplay } from "swiper/modules";
import HotGameSection from "./components/HotGameSection.vue";
import GameCard from "@/components/GameCard.vue";
import TabItem from "@/components/home/TabItem.vue";
import ProviderCard from "@/components/ProviderCard.vue";

export default {
  components: {
    NoticeBar,
    Sticky,
    LiveChatWidget,
    Swiper,
    SwiperSlide,

    TabItem,
    HotGameSection,
    ProviderCard,
    GameCard,
  },
  data() {
    return {
      testing: true,
      isLoading: false,
      twoDdata: {},
      twoDHistories: {},
      threeDHistories: {},
      threedData: {},
      websiteInfo: {
        home_banners: {},
        noticeText: "This is a notice",
      },
      activeNoticeText: "",
      isLogged: false,
      hotGames: {
        slotGames: [],
        fishingGames: [],
        arcadeGames: [],
      },
      limitText: "",
      desiredGame: null,
    };
  },
  computed: {
    ...mapState('providers', [
      'slotProviders',
      'fishProviders',
      'arcadeProviders',
      'liveProviders',
      'isProvidersFetching',
    ]),
  },
  methods: {
    ...mapActions('providers', ['fetchActiveProviders']),

    async gameInitCasino(game) {
      try {
        this.isLoading = true;
        const authUser = await this.fetchUser();
        if (!authUser) {
          this.$router.push("/auth/login");
        }

        const res = await axios.get(
          "https://api.shwespin777.com/api/games/url",
          {
            params: {
              provider: game,
            },
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );

        window.location.assign(res.data.data.gameUrl);

        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
      }
    },
    hideLimit() {
      $("#limit").modal("hide");
    },
    showAlertBox(game) {
      if (game.provider === "PGSoft")
        this.limitText = "PG Soft တွင် 1K unit သည် 1,000 ကျပ်နှင့်ညီမျပါသည်။";
      else if (game.provider === "FaChai")
        this.limitText =
          "FaChai Provider တွင် 1 unit သည် 100 ကျပ်နှင့်ညီမျပါသည်။";
      // else this.limitText = '5G Provider တွင် 1K unit သည် 100 ကျပ်နှင့်ညီမျပါသည်။';
      $("#limit").modal("show");
      this.desiredGame = game;
    },

    async gameInit(game) {
      try {
        this.$store.commit("setLoading", true);
        const authUser = await this.fetchUser();
        if (!authUser) {
          this.$router.push("/auth/login");
        }

        const res = await axios.get(
          "https://api.shwespin777.com/api/games/url",
          {
            params: {
              gameID: game.gameID,
              provider: game.provider,
            },
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );

        // this.$store.commit('setIframeURL', res.data.data.gameUrl);
        // this.$router.push('/iframeURL');
        if (game.provider === "PGSoft") {
          const newPage = window.open("", "_self");

          // Write HTML content into the new window
          if (newPage) {
            newPage.document.open();
            newPage.document.write(res.data.data.gameUrl);
            newPage.document.close();
          }
        } else {
          window.open(res.data.data.gameUrl, "_self");
        }

        this.$store.commit("setLoading", false);
      } catch (error) {
        this.$store.commit("setLoading", false);
      }
    },

    scrollToElement() {
      const container = this.$el.querySelector(".index_rightbar");
      // Scroll to the target element within the container
      if (container) {
        container.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      }
    },
    async fetchBetGame(game = null, link = null) {
      try {
        this.isLoading = true;

        if (game) {
          this.gameName = game;
          this.gameLink = link;
        }
        const res = await axios.get(`/${this.gameName}-data`, {
          params: {
            id: this.$store.state.authUser.name,
            balance: this.$store.state.authUser.amount,
            info: {
              nickname: this.$store.state.authUser.user_name,
              profile: 3,
            },
          },
        });
        window.location.assign(
          `https://${link}.vercel.app/?id=${this.$store.state.authUser.name}&passcode=${res.data.passcode}&exit=https%3A%2F%2F${window.location.host}/home`
        );
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        console.log(error);
      }
    },

    async fetchForestData() {
      // if(this.$store.state.authUser.game_balance < 1000) {
      //   this.alertBoxForLimit();
      //   return false;
      // }
      try {
        this.isLoading = true;
        const authUser = await this.fetchUser();
        if (!authUser) {
          this.$router.push("/auth/login");
        }

        // if(this.nickname && this.nickname !== ''){
        const res = await axios.get("/forest-data", {
          params: {
            id: this.$store.state.authUser.name,
            balance: this.$store.state.authUser.game_balance,
          },
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });

        if (res.data.url) {
          window.location.assign(res.data.url);
        } else {
          Dialog.alert({
            message: res.data.description,
            confirmButtonText:
              this.$store.state.language === "en"
                ? "Go Back"
                : "နောက်သို့ပြန်သွားမည်။",
          });
        }

        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        console.log(error);
      }
    },

    async fetchGaloneData() {
      // if(this.$store.state.authUser.game_balance < 1000) {
      //   this.alertBoxForLimit();
      //   return false;
      // }
      try {
        this.isLoading = true;
        const authUser = await this.fetchUser();
        if (!authUser) {
          this.$router.push("/auth/login");
        }

        // if(this.nickname && this.nickname !== ''){
        const res = await axios.get("/galone-data", {
          params: {
            id: this.$store.state.authUser.name,
            balance: this.$store.state.authUser.game_balance,
          },
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });

        if (res.data.url) {
          window.location.assign(res.data.url);
        } else {
          Dialog.alert({
            message: res.data.description,
            confirmButtonText:
              this.$store.state.language === "en"
                ? "Go Back"
                : "နောက်သို့ပြန်သွားမည်။",
          });
        }

        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        console.log(error);
      }
    },

    async fetchGaloneGalone() {
      if (this.$store.state.authUser.game_balance < 1000) {
        this.alertBoxForLimit();
        return false;
      }
      try {
        this.isLoading = true;
        const authUser = await this.fetchUser();
        if (!authUser) {
          this.$router.push("/auth/login");
        }

        // if(this.nickname && this.nickname !== ''){
        const res = await axios.get("/galone-galone", {
          params: {
            id: this.$store.state.authUser.name,
            balance: this.$store.state.authUser.game_balance,
          },
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });

        if (res.data.url) {
          window.location.assign(res.data.url);
        } else {
          Dialog.alert({
            message: res.data.description,
            confirmButtonText:
              this.$store.state.language === "en"
                ? "Go Back"
                : "နောက်သို့ပြန်သွားမည်။",
          });
        }

        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        console.log(error);
      }
    },

    async fetchBugyee(level = null) {
      try {
        this.isLoading = true;
        const authUser = await this.fetchUser();
        if (!authUser) {
          this.$router.push("/auth/login");
        }

        const amount = authUser.amount;
        if (level == 0 && amount < 1000) {
          this.limitText =
            "1,000 အောက်ရောက်နေပါသည်။ ငွေထပ်မံဖြည့်သွင်းပြီးမှ သည်အခန်းကို ဆော့လို့ရပါမည်။";
          $("#limit").modal("show");
          this.isLoading = false;
          return false;
        }
        if (level == 0 && amount > 100000) {
          this.limitText =
            "သတ်မှတ်ထားသော ငွေပမာဏထပ် ကျော်လွန်နေပါသည်။ သင့်လျော်သောအခန်းတွင်သာ ကစားပေးပါ။";
          $("#limit").modal("show");
          this.isLoading = false;
          return false;
        }

        if (level == 1 && amount < 3000) {
          this.limitText =
            "3,000 အောက်ရောက်နေပါသည်။ ငွေထပ်မံဖြည့်သွင်းပြီးမှ သည်အခန်းကို ဆော့လို့ရပါမည်။";
          $("#limit").modal("show");
          this.isLoading = false;
          return false;
        }
        if (level == 1 && amount > 300000) {
          this.limitText =
            "သတ်မှတ်ထားသော ငွေပမာဏထပ် ကျော်လွန်နေပါသည်။ သင့်လျော်သောအခန်းတွင်သာ ကစားပေးပါ။";
          $("#limit").modal("show");
          this.isLoading = false;
          return false;
        }

        if (level == 2 && amount < 5000) {
          this.limitText =
            "5,000 အောက်ရောက်နေပါသည်။ ငွေထပ်မံဖြည့်သွင်းပြီးမှ သည်အခန်းကို ဆော့လို့ရပါမည်။";
          $("#limit").modal("show");
          this.isLoading = false;
          return false;
        }
        if (level == 2 && amount > 500000) {
          this.limitText =
            "သတ်မှတ်ထားသော ငွေပမာဏထပ် ကျော်လွန်နေပါသည်။ သင့်လျော်သောအခန်းတွင်သာ ကစားပေးပါ။";
          $("#limit").modal("show");
          this.isLoading = false;
          return false;
        }

        if (level == 3 && amount < 10000) {
          this.limitText =
            "10,000 အောက်ရောက်နေပါသည်။ ငွေထပ်မံဖြည့်သွင်းပြီးမှ သည်အခန်းကို ဆော့လို့ရပါမည်။";
          $("#limit").modal("show");
          this.isLoading = false;
          return false;
        }
        if (level == 4 && amount < 30000) {
          this.limitText =
            "30,000 အောက်ရောက်နေပါသည်။ ငွေထပ်မံဖြည့်သွင်းပြီးမှ သည်အခန်းကို ဆော့လို့ရပါမည်။";
          $("#limit").modal("show");
          this.isLoading = false;
          return false;
        }
        if (level == 5 && amount < 50000) {
          this.limitText =
            "50,000 အောက်ရောက်နေပါသည်။ ငွေထပ်မံဖြည့်သွင်းပြီးမှ သည်အခန်းကို ဆော့လို့ရပါမည်။";
          $("#limit").modal("show");
          this.isLoading = false;
          return false;
        }

        const res = await axios.get("/bugyee-data", {
          params: {
            id: this.$store.state.authUser.name,
            level,
            balance: this.$store.state.authUser.amount,
            info: {
              nickname: this.$store.state.authUser.user_name,
              profile: 3,
            },
          },
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });
        // console.log(res.data)
        window.location.assign(res.data.url);
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        console.log(error);
      }
    },

    async fetchShanKoMeeData(level = null) {
      try {
        this.isLoading = true;
        const authUser = await this.fetchUser();
        if (!authUser) {
          this.$router.push("/auth/login");
        }

        const amount = authUser.amount;
        if (level == 0 && amount < 1000) {
          this.limitText =
            "1,000 အောက်ရောက်နေပါသည်။ ငွေထပ်မံဖြည့်သွင်းပြီးမှ သည်အခန်းကို ဆော့လို့ရပါမည်။";
          $("#limit").modal("show");
          this.isLoading = false;
          return false;
        }
        if (level == 0 && amount > 100000) {
          this.limitText =
            "သတ်မှတ်ထားသော ငွေပမာဏထပ် ကျော်လွန်နေပါသည်။ သင့်လျော်သောအခန်းတွင်သာ ကစားပေးပါ။";
          $("#limit").modal("show");
          this.isLoading = false;
          return false;
        }

        if (level == 1 && amount < 3000) {
          this.limitText =
            "3,000 အောက်ရောက်နေပါသည်။ ငွေထပ်မံဖြည့်သွင်းပြီးမှ သည်အခန်းကို ဆော့လို့ရပါမည်။";
          $("#limit").modal("show");
          this.isLoading = false;
          return false;
        }
        if (level == 1 && amount > 300000) {
          this.limitText =
            "သတ်မှတ်ထားသော ငွေပမာဏထပ် ကျော်လွန်နေပါသည်။ သင့်လျော်သောအခန်းတွင်သာ ကစားပေးပါ။";
          $("#limit").modal("show");
          this.isLoading = false;
          return false;
        }

        if (level == 2 && amount < 5000) {
          this.limitText =
            "5,000 အောက်ရောက်နေပါသည်။ ငွေထပ်မံဖြည့်သွင်းပြီးမှ သည်အခန်းကို ဆော့လို့ရပါမည်။";
          $("#limit").modal("show");
          this.isLoading = false;
          return false;
        }
        if (level == 2 && amount > 500000) {
          this.limitText =
            "သတ်မှတ်ထားသော ငွေပမာဏထပ် ကျော်လွန်နေပါသည်။ သင့်လျော်သောအခန်းတွင်သာ ကစားပေးပါ။";
          $("#limit").modal("show");
          this.isLoading = false;
          return false;
        }

        if (level == 3 && amount < 10000) {
          this.limitText =
            "10,000 အောက်ရောက်နေပါသည်။ ငွေထပ်မံဖြည့်သွင်းပြီးမှ သည်အခန်းကို ဆော့လို့ရပါမည်။";
          $("#limit").modal("show");
          this.isLoading = false;
          return false;
        }
        if (level == 4 && amount < 30000) {
          this.limitText =
            "30,000 အောက်ရောက်နေပါသည်။ ငွေထပ်မံဖြည့်သွင်းပြီးမှ သည်အခန်းကို ဆော့လို့ရပါမည်။";
          $("#limit").modal("show");
          this.isLoading = false;
          return false;
        }
        if (level == 5 && amount < 50000) {
          this.limitText =
            "50,000 အောက်ရောက်နေပါသည်။ ငွေထပ်မံဖြည့်သွင်းပြီးမှ သည်အခန်းကို ဆော့လို့ရပါမည်။";
          $("#limit").modal("show");
          this.isLoading = false;
          return false;
        }

        // if(this.nickname && this.nickname !== ''){
        const res = await axios.get("/shankomee-data", {
          params: {
            id: this.$store.state.authUser.name,
            level,
            balance: this.$store.state.authUser.amount,
            info: {
              nickname: this.$store.state.authUser.user_name,
              profile: 3,
            },
          },
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });
        // console.log(res.data)
        window.location.assign(res.data.url);
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        console.log(error);
      }
    },
    changeSideNav(para) {
      this.$store.commit("updateSideNav", para);
      this.scrollToElement();
    },
    ...mapActions(["logoutUser", "fetchUser"]),
    async redirectRoute(path, query = null) {
      try {
        console.log("query", query);
        if (query) {
          this.$router.push({ path, query });
        } else {
          this.$router.push(path);
        }
      } catch (error) {
        console.log(error);
      }
    },

    logout() {
      Dialog.confirm({
        title:
          this.$store.state.language === "en"
            ? "Are you sure to log out?"
            : "ထွက်မှာ သေချာပါသလား?",
        cancelButtonText:
          this.$store.state.language === "en" ? "Cancel" : "မထွက်တော့ပါ",
        confirmButtonText:
          this.$store.state.language === "en" ? "Sure" : "သေချာပြီ",
      })
        .then(async () => {
          await this.logoutUser();
          this.$router.push("/auth/login");
          Toast.success(
            this.$store.state.language === "en" ? "Logged out!" : "ထွက်ပြီးပြီ"
          );
        })
        .catch(() => { });
    },
    async redirectRoute(path, query = null) {
      try {
        if (path === "tip") {
          const text =
            this.$store.state.language === "en"
              ? "This feature is not support yet."
              : "ယခုအချိန်တွင် အသုံးပြုလို့မရနိုင်သေးပါ။";
          Dialog.alert({
            message: text,
            confirmButtonText:
              this.$store.state.language === "en" ? "Okay" : "Okay",
          }).then(() => {
            // on close
          });
        } else if (query) {
          this.$router.push({ path, query });
        } else {
          this.$router.push(path);
        }
      } catch (error) {
        console.log(error);
      }
    },
    threedDrawDateFormat(date) {
      return moment(date).format("ll");
    },
    async fetchTwoDdata() {
      try {
        const res = await axios.get("/2d/data");
        this.isLive = res.data.data[0].isLive;
      } catch (error) {
        console.log(error);
      }
    },
    async fetchWebsiteData() {
      try {
        const res = await axios.get("/website-infos");
        const activeNoticeTextResponse = await axios.get("/active-notice");
        // console.log("ACTIVE NOCIE TEXT", activeNoticeTextResponse);
        this.websiteInfo = res.data.data[0];
        this.activeNoticeText = activeNoticeTextResponse.data.active_notice;
      } catch (error) {
        console.log(error);
      }
    },
    async fetchThreedDdata() {
      try {
        const res = await axios.get("/3d/data");
        this.threedData = res.data.data[0];
      } catch (error) {
        console.log(error);
      }
    },
    async fetchHotGames() {
      try {
        const { data } = await axios.get("/hot-games");
        this.hotGames = data.data;
      } catch (error) {
        console.log(error);
      }
    },
    async fetchTwoThreeDHistories() {
      try {
        const twoDres = await axios.get("/twod_history");
        const threeDres = await axios.get("/threed_history");
        this.twoDHistories = twoDres.data.data;
        this.threeDHistories = threeDres.data.data;
      } catch (error) {
        console.log(error);
      }
    },
    // Function to load the Tawt.io chat widget
    // loadTawkChat() {
    //   console.log('here1')
    //   if (!document.getElementById('tawk-io-chat')) {
    //     console.log('here2')
    //     var Tawk_API = Tawk_API || {}, Tawk_LoadStart = new Date();

    //     // Dynamically add the script to load Tawt.io
    //     var s1 = document.createElement("script");
    //     var s0 = document.getElementsByTagName("script")[0];
    //     s1.async = true;
    //     s1.id = 'tawk-io-chat';
    //     s1.src = 'https://embed.tawk.to/66ed95584cbc4814f7dc1919/1i880up29';
    //     s1.charset = 'UTF-8';
    //     s1.setAttribute('crossorigin', '*');
    //     s0.parentNode.insertBefore(s1, s0);

    //     // Apply custom styles when the widget loads
    //     Tawk_API.onLoad = () => {
    //       this.applyCustomStyles();
    //       setInterval(this.applyCustomStyles, 1000);
    //     };
    //   }
    // },
    // Function to apply custom styles to the Tawk.to iframe
    // applyCustomStyles() {
    //   var tawkIframe = document.querySelector('iframe[title="chat widget"]');
    //   if (tawkIframe) {
    //     tawkIframe.style.bottom = '7rem'; // Adjust this as needed
    //     tawkIframe.style.left = '1rem';
    //     tawkIframe.style.right = '0rem';
    //   }
    // },
    // // Function to remove the Tawt.io script and widget
    // removeTawkChat() {
    //   const tawkScript = document.getElementById('tawk-io-chat');
    //   if (tawkScript) {
    //     tawkScript.remove(); // Remove the script tag
    //   }

    //   // Remove the Tawk.to iframe widget
    //   const tawkIframe = document.querySelector('iframe[title="chat widget"]');
    //   if (tawkIframe) {
    //     tawkIframe.remove();
    //   }
    // }
  },
  setup() {
    return {
      Pagination,
      Autoplay,
    };
  },
  destroyed() {
    this.testing = false;
  },
  async mounted() {
    this.$store.commit("setLoading", true);
    await this.fetchWebsiteData();
    await this.fetchHotGames();
    await this.fetchActiveProviders();
    this.$store.commit("setLoading", false);
  },
  beforeDestroy() {
    // this.removeTawkChat();
  },
};
</script>

<style scoped>
.pulse {
  animation: pulse 1s ease-in-out infinite;
}

@keyframes pulse {
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(1.05);
  }

  100% {
    transform: scale(1);
  }
}


@keyframes pulse {
  0% {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
  }

  50% {
    -webkit-transform: scale3d(1.05, 1.05, 1.05);
    transform: scale3d(1.05, 1.05, 1.05);
  }

  100% {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
  }
}

.side-nav-icon-text {
  /* color: #A80000; */
  font-size: 0.9rem;
  /* color: #382618; */
}

.side-nav-icon {
  position: relative;
  cursor: pointer;
  overflow: hidden;
  font-weight: 600;
  color: #ccc !important;
  background: transparent;
  border: 1px solid #434f64;
  /* box-shadow: rgba(40, 40, 40, 0.4) 0 2px 4px, rgba(40, 40, 40, 0.4) 0 7px 13px -3px, #000000 0 0 0 inset; */
  /* box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px; */
}

.side-nav-icon.active {
  /* background: #A80000; */
  /* background: linear-gradient(10deg,#CF05D2,#e8a3e9); */
  /* color: black !important; */
  /* box-shadow: rgba(40, 40, 40, 0.4) 0 2px 4px, rgba(40, 40, 40, 0.4) 0 7px 13px -3px, #01ff3c 0 -3px 0 inset; */
  border: 1px solid #d2a038 !important;
}

.side-nav-icon-text.active {
  background: #c7a241;
  color: black;
  /* padding: 1px 10px; */
  border: none;
  width: 90%;
  text-align: center;
  border-radius: 5px;
  /* font-weight: bold; */
  cursor: pointer;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.3);
  /* font-size: 16px; */
}

.sidebar {
  position: fixed;
  /* top: 23.5rem; */
  left: 0;
  height: 55vh;
  padding-bottom: 50px;
  scrollbar-width: none;
  /* For Firefox */
  -ms-overflow-style: none;
  /* For Internet Explorer and Edge */
  overflow-y: auto;
}

.index_rightbar {
  padding: 0px 10px;
  overflow-y: scroll;
  height: 55vh;
  scrollbar-width: none;
  /* For Firefox */
  -ms-overflow-style: none;
  /* For Internet Explorer and Edge */
}

.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.detail-button {
  appearance: none;
  background-color: transparent;
  border: 2px solid #714dc7;
  text-transform: uppercase;
  border-radius: 10px;
  box-sizing: border-box;
  color: #714dc7;
  cursor: pointer;
  display: inline-block;
  font-family: Roobert, -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica,
    Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
  font-size: 0.9rem;
  font-weight: 450;
  line-height: normal;
  margin: 0;
  min-height: 15px;
  min-width: 0;
  outline: none;
  padding: 5px 10px;
  text-align: center;
  text-decoration: none;
  transition: all 300ms cubic-bezier(0.23, 1, 0.32, 1);
  user-select: none;
  touch-action: manipulation;
  width: 100%;
  will-change: transform;
}

.detail-button:disabled {
  pointer-events: none;
}

.detail-button:hover {
  color: #fff;
  background-color: #714dc7;
  box-shadow: rgba(0, 0, 0, 0.25) 0 8px 15px;
  transform: translateY(-2px);
}

.detail-button:active {
  box-shadow: none;
  transform: translateY(0);
}

.nav-pills.game-nav {
  padding-right: 5px;
}

.nav-pills .nav-link {
  border-radius: 10px !important;
  margin-bottom: 5px;
  /* padding: 10px; */
  font-size: 10px !important;
  text-align: center;
  color: #ffffff;
  /* background: linear-gradient(#aa9ace, #714DC7); */
}

.nav-item {
  padding-right: 0;
  margin-bottom: 0;
  width: 12rem;
}

.nav-pills .nav-link img {
  width: 18px !important;
  /* margin-right: 10px; */
  padding-bottom: 4px;
}

.nav-pills .nav-link.active,
.nav-pills .show>.nav-link {
  color: #fff !important;
  background: linear-gradient(#fff, #8a69d9);
}

.nav {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}

.tab-content.game a img {
  /* box-shadow: 0px 3px 14px -5px rgba(0, 0, 0, 0.4); */
  border-radius: 21px;
  margin-bottom: 10px;
  width: 100%;
}

.tab-content.game {
  padding-left: 3px;
}

.tab-content>.tab-pane {
  display: none;
  padding-right: 3px;
}

.tab-content>.active {
  display: block;
}

.css-38745a {
  margin: 0px;
  line-height: 1.5;
  font-size: 12px;
  font-family: NotoSansMyanmar;
  font-weight: 500;
}

.css-17h40hp {
  margin: 0px;
  line-height: 1.5;
  font-size: 14px;
  font-family: NotoSansMyanmar;
  font-weight: 700 !important;
}

.card {
  cursor: pointer;
  border-radius: 10px !important;
}

.main-image-wrapper img {
  width: 100%;
}

.video-container {
  height: 500px;
  width: 100%;
}

.notice-bar {
  margin-top: -40px;
  z-index: 1;
  font-size: 20px;
  color: rgb(162 141 96 / 1) !important;
  background: transparent;
}

.twod-threed-cards {
  height: 200px;
}

.live-number {
  font-weight: bold;
  font-size: 25px;
}

.live-result {
  font-weight: bolder;
  font-size: 60px;
  animation-name: live-number-animation;
  animation-duration: 2s;
  animation-iteration-count: infinite;
}

.not-live-text {
  font-weight: bold;
  font-size: 24px;
}

.cards-container {
  display: flex;
  flex-wrap: wrap;
}

.card-body {
  padding: 0px !important;
}

.cards-container-mobile {
  display: none;
}

@keyframes live-number-animation {
  from {
    color: white;
  }

  to {
    color: red;
  }
}

/* @media (max-width: 768px) { */
/* .middle-container {
    padding-top: 0.1rem !important;
  } */
hr {
  margin-top: 0px;
  margin-bottom: 0px;
}

.video-container {
  height: 300px;
  width: 100%;
}

.main-wrapper {
  padding: 7px !important;
}

.notice-bar {
  margin-top: 0px;
  height: 25px;
  z-index: 1;
  font-size: 1rem;
  color: white !important;
  background: transparent;
  border-radius: 7px;
}

.live-number {
  font-weight: bold;
  font-size: 20px;
}

.live-result {
  font-weight: bolder;
  font-size: 37px;
}

.cards-container {
  display: none;
}

.cards-container-mobile {
  padding: 0px !important;
  margin-top: 5px !important;
  display: flex;
  flex-wrap: wrap;
}

.home-cards {
  padding-left: 10px;
  padding-right: 10px;
}

.card-body {
  padding: 0px !important;
}

.not-live-text {
  font-size: 18px;
  padding-left: 10px;
  padding-right: 10px;
}

.account-container-wrapper {
  width: auto;
  height: auto;
  border-radius: 10px;
  padding-left: 4px;
  padding-right: 4px;
  margin-top: 10px !important;
  margin-left: 10px;
  margin-right: 10px;
  color: #000000;
  /* background: linear-gradient(#aa9ace, #714DC7); */
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}

.top-wrapper,
.bottom-wrapper {
  padding: 10px;
  width: 100%;
  display: flex;
}

.top-right,
.bottom-right {
  width: 50%;
  height: 100%;
  display: flex;
  justify-content: end;
}

.top-left,
.bottom-left {
  width: 50%;
  height: 100%;
  display: flex;
  justify-content: start;
}

.info-swiper .swiper-slide {
  transition: transform 0.4s ease, opacity 0.4s ease;
  transform: scale(0.9);
  opacity: 0.5;
}

.info-swiper .swiper-slide-active {
  transform: scale(1);
  opacity: 1;
}

/* } */
</style>
